import { axiosInstance } from "@/config/axiosInstance";

//  ****** GET ALL TODOS ******
export const getAllTodosForAdmin =
  (adminKey: string) => (dates: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        todos?: {
          _id: string;
          createdAt: Date | string;
          deadline: Date | string;
          files: string[];
          title: string;
          description: string;
          recipients: {
            _id: string;
            name: string;
          }[];
          tasks: {
            _id: string;
            createdAt: string | Date;
            files: string[];
            recipient: string;
            status: string;
            description: string;
          }[];
        }[];
      }>(`/todo/admin/fetch/all`, dates, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ONE TODO ******
export const getOneTodoForAdmin = (adminKey: string) => (todoId: string) =>
  axiosInstance
    .get<{
      success: boolean;
      error?: string;
      todo?: {
        _id: string;
        createdAt: Date | string;
        files: string[];
        title: string;
        description: string;
        recipients: {
          _id: string;
          name: string;
        }[];
        tasks: {
          _id: string;
          createdAt: string | Date;
          files: string[];
          recipient: string;
          status: string;
          description: string;
        }[];
      };
    }>(`/todo/admin/one/${todoId}`, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);
